import "./google-analytics"
$(function(){

    $("#profile-avatar-navigation-button").on("click", function(){
        var dropdown = $("#profile-dropdown-area")
        if (dropdown.hasClass("opacity-0")) {
            dropdown.addClass("transform opacity-100 scale-100")
            dropdown.removeClass("transform opacity-0 scale-95")
        }else{
            dropdown.removeClass("transform opacity-100 scale-100")
            dropdown.addClass("transform opacity-0 scale-95")
        }
    })

    $("#account_logo_trigger").on("click", function(e){
        $("#account_logo").trigger('click');
        e.preventDefault();
    });

    $("#account_banner_trigger").on("click", function(e){
        $("#account_banner").trigger('click');
        e.preventDefault();
    });

   
    $("#account_favicon_trigger").on("click", function(e){
        $("#account_favicon").trigger('click');
        e.preventDefault();
    });

    $("#user_avatar_trigger").on("click", function(e){
        $("#user_avatar").trigger('click');
        e.preventDefault();
    });

    // Use delegated events so bindings survive Turbolinks page replacements
    $(document).on("click", "#change_school_button", function(e){
        e.preventDefault();
        $("#schoolSearchModal").show();
    });

    $(document).on("click", "#choose_school_button", function(e){
        e.preventDefault();
        $("#schoolSearchModal").show();
    });

    // Allow users to reopen the school selector by clicking the selected school field
    $(document).on("click", "#selected_school_name", function(e){
        e.preventDefault();
        $("#schoolSearchModal").show();
    });

    window.addEventListener("school:selected", function(event){
        const {id, name} = event.detail;
        $("input[name='user[school_id]']").val(id);
        $("#selected_school_name").val(name).show();
        $("#choose_school_button").hide();
    });

})
